var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 9.99984C18.3346 14.6022 14.6037 18.3332 10.0013 18.3332M18.3346 9.99984C18.3346 5.39746 14.6037 1.6665 10.0013 1.6665M18.3346 9.99984H1.66797M10.0013 18.3332C5.39893 18.3332 1.66797 14.6022 1.66797 9.99984M10.0013 18.3332C12.0857 16.0512 13.2703 13.0898 13.3346 9.99984C13.2703 6.90987 12.0857 3.94846 10.0013 1.6665M10.0013 18.3332C7.9169 16.0512 6.73234 13.0898 6.66797 9.99984C6.73234 6.90987 7.9169 3.94846 10.0013 1.6665M1.66797 9.99984C1.66797 5.39746 5.39893 1.6665 10.0013 1.6665",
    stroke: "#7F818D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.502642235704b18379aa77e7dbe26d37.svg";
export { ForwardRef as ReactComponent };